import { render } from "./BatchClassList.vue?vue&type=template&id=69766454&scoped=true&ts=true"
import script from "./BatchClassList.vue?vue&type=script&lang=ts"
export * from "./BatchClassList.vue?vue&type=script&lang=ts"

import "./BatchClassList.vue?vue&type=style&index=0&id=69766454&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69766454"]])

export default __exports__